import React, { useEffect, useState } from 'react';
import { ColumnsType } from 'antd/lib/table';
import Icon from '@ant-design/icons';
import { useFormik } from 'formik';
import { Modal } from 'antd';

import { useAppDispatch, useAppSelector } from 'src/stores';
import { deleteButtonAction, getOneClickAction } from 'src/stores/screens/privateScreens/common/common.action';
import { MasterManagement } from 'src/interfaces/pages/masterManagement';
import { PencilEditIcon, WarningModalIcon } from 'src/assets/icons';
import DeleteRowTableIcon from 'src/assets/icons/delete-row-table-icon';
import { MESSAGE_POPUP } from 'src/shared/constants/message';
import { getTerminalAction } from 'src/stores/screens/privateScreens/terminals/terminals.action';

const { confirm } = Modal;

function useInit(): MasterManagement.UseInitOneClick {
  const dispatch = useAppDispatch();

  const { oneClick, totalPageOneClicks, isLoading } = useAppSelector(state => state.common);
  const { meInfo } = useAppSelector(state => state.auth);
  const { terminals } = useAppSelector(state => state.terminals);

  const [dataEdit, setDataEdit] = useState<DashboardStore.Button | null>(null);
  const [terminalId, setTerminalId] = useState<any>(null);
  const [isShowModal, setIsShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const pageSize = 10;

  const columns: ColumnsType<any> = [
    {
      title: 'No',
      dataIndex: '',
      key: 'no',
      width: '110px',
      render: (_, record, index) => {
        const no = startIndex + index < pageSize ? `0${startIndex + index}` : startIndex + index;

        return <>{no}</>;
      },
    },
    {
      title: '端末番号',
      dataIndex: 'serialNum',
      key: 'serialNum',
    },
    {
      title: 'グループ名',
      dataIndex: 'label',
      key: 'label',
      render: (_, record) => <>{record?.label?.name}</>,
    },
    {
      title: 'アクション',
      dataIndex: 'actions',
      key: 'actions',
      align: 'right',
      render: (_, record) => (
        <React.Fragment>
          <Icon
            component={PencilEditIcon}
            onClick={() => {
              setDataEdit(record);
              setIsShowModal(true);
            }}
          />
          <Icon
            component={DeleteRowTableIcon}
            onClick={() => {
              showConfirm(record.id);
            }}
          />
        </React.Fragment>
      ),
    },
  ];

  const formik = useFormik({
    initialValues: {
      terminalId: terminalId ?? meInfo?.terminalId,
    },
    onSubmit: () => {},
  });

  const fetchDataOneClick = async (params?: CommonStore.ParamsGetList): Promise<void> => {
    await dispatch(
      getOneClickAction({
        data: { size: 10, page: currentPage, terminalId: terminalId ?? meInfo?.terminalId, haveLabel: true, ...params },
      }),
    );
  };

  const dataSelectTerminals = terminals?.map(item => {
    return {
      label: item.name,
      value: item.id,
    };
  });

  useEffect(() => {
    void fetchDataOneClick();
    void dispatch(getTerminalAction({ data: {} }));
  }, []);

  useEffect(() => {
    const calculateStartIndex = (): void => {
      const newStartIndex = (currentPage - 1) * pageSize + 1;
      setStartIndex(newStartIndex);
    };

    calculateStartIndex();
  }, [currentPage]);

  const showConfirm = (id: number): void => {
    confirm({
      title: MESSAGE_POPUP.ARE_YOU_SURE_DELETE,
      icon: <Icon component={WarningModalIcon} />,
      onOk() {
        void dispatch(
          deleteButtonAction({
            id,
            callback: () => {
              void fetchDataOneClick();
            },
          }),
        );
      },
      onCancel() {},
      okText: MESSAGE_POPUP.DELETE,
      cancelText: MESSAGE_POPUP.CANCEL,
    });
  };

  useEffect(() => {
    if (!isShowModal) {
      setDataEdit(null);
    }
  }, [isShowModal]);

  return {
    columns,
    dataSource: oneClick,
    isLoading,
    totalPageOneClicks,
    formik,
    currentPage,
    dataEdit,
    isShowModal,
    dataSelectTerminals,
    terminalId,
    setDataEdit,
    setIsShowModal,
    fetchDataOneClick,
    setCurrentPage,
    setTerminalId,
  };
}

export default useInit;
